import { ClientMobileAppsData } from '../typings/state';

export const REQUEST_CLIENT_MOBILE_APPS_DATA = 'REQUEST_CLIENT_MOBILE_APPS_DATA';
export type REQUEST_CLIENT_MOBILE_APPS_DATA = typeof REQUEST_CLIENT_MOBILE_APPS_DATA;

export interface RequestClientMobileAppsData {
    type: REQUEST_CLIENT_MOBILE_APPS_DATA;
}

export function requestClientMobileAppsData(): RequestClientMobileAppsData {
    return {
        type: REQUEST_CLIENT_MOBILE_APPS_DATA
    };
}

export const UPDATE_CLIENT_MOBILE_APPS_DATA = 'UPDATE_CLIENT_MOBILE_APPS_DATA';
export type UPDATE_CLIENT_MOBILE_APPS_DATA = typeof UPDATE_CLIENT_MOBILE_APPS_DATA;

export interface UpdateClientMobileAppsData {
    type: UPDATE_CLIENT_MOBILE_APPS_DATA;
    data?: ClientMobileAppsData;
}

export function updateClientMobileAppsData(data?: ClientMobileAppsData): UpdateClientMobileAppsData {
    return {
        type: UPDATE_CLIENT_MOBILE_APPS_DATA,
        data
    };
}

export type ClientMobileAppsDataAction = RequestClientMobileAppsData | UpdateClientMobileAppsData;
